import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class DeeplinksService {
  deeplink$: BehaviorSubject<string>;
  customersDeepLink$: BehaviorSubject<string>;
  deviceOpsDeepLink$: BehaviorSubject<string>;

  constructor(private apiService: ApiService) {
    this.deeplink$ = new BehaviorSubject<string>('');
    this.customersDeepLink$ = new BehaviorSubject<string>('');
    this.deviceOpsDeepLink$ = new BehaviorSubject<string>('');
  }

  async setMarketAdminUrl() {
    try {
      const url = await this.apiService.get('deeplinks/markets/');
      this.deeplink$.next(url + '/create');
    } catch (err) {
      console.log('Could not load market admin url.', err);
    }
  }

  async setCustomerAdminUrl() {
    try {
      const url = await this.apiService.get('deeplinks/customers/');
      this.customersDeepLink$.next(url);
    } catch (err) {
      console.log('Could not load asset admin url.', err);
    }
  }

  async setDeviceOpsUrl() {
    try {
      const url = await this.apiService.get('deeplinks/device/');
      this.deviceOpsDeepLink$.next(url);
    } catch (err) {
      console.log('Could not load asset admin url.', err);
    }
  }
}
